declare global {
  interface Window {
    dataLayer: Record<string, any>[]
  }
}

window.dataLayer = window.dataLayer || []

export const triggerStartEvent = () => {
  window.dataLayer.push({
    event: "ga4_event",
    event_name: "HVAC_quiz_start",
    HVAC_quiz_start: {
      eventCategory: "HVAC quiz",
      eventAction: "start",
      eventLabel: undefined,
    },
  })
}

export const triggerMoreQuestionsEvent = () => {
  window.dataLayer.push({
    event: "ga4_event",
    event_name: "HVAC_quiz_step1_yes",
    HVAC_quiz_step1_yes: {
      eventCategory: "HVAC quiz",
      eventAction: "step1 yes",
      eventLabel: undefined,
    },
  })
}

export const triggerLessQuestionsEvent = () => {
  window.dataLayer.push({
    event: "ga4_event",
    event_name: "HVAC_quiz_step1_no",
    HVAC_quiz_step1_no: {
      eventCategory: "HVAC quiz",
      eventAction: "step1 no",
      eventLabel: undefined,
    },
  })
}

export const triggerNextEvent = (quizz_step_number: string) => {
  window.dataLayer.push({
    event: "ga4_event",
    event_name: "HVAC_quiz_click_next",
    HVAC_quiz_click_next: {
      step_number: quizz_step_number, // e.g. 1|2|3| etc.
      eventCategory: "HVAC quiz",
      eventAction: "click next",
      eventLabel: quizz_step_number, // e.g. 1|2|3| etc.
    },
  })
}

export const triggerBackEvent = (quizz_step_number: string) => {
  window.dataLayer.push({
    event: "ga4_event",
    event_name: "HVAC_quiz_click_back",
    HVAC_quiz_click_back: {
      step_number: quizz_step_number, // e.g. 1|2|3| etc.
      eventCategory: "HVAC quiz",
      eventAction: "click back",
      eventLabel: quizz_step_number, // e.g. 1|2|3| etc.
    },
  })
}

export const triggerRetryEvent = () => {
  window.dataLayer.push({
    event: "ga4_event",
    event_name: "HVAC_quiz_click_retry",
    HVAC_quiz_click_retry: {
      eventCategory: "HVAC quiz",
      eventAction: "click retry",
      eventLabel: undefined,
    },
  })
}

export const triggerDownloadEvent = (filename: string) => {
  window.dataLayer.push({
    event: "ga4_event",
    event_name: "HVAC_quiz_download",
    HVAC_quiz_download: {
      file_name: filename,
      eventCategory: "HVAC quiz",
      eventAction: "download",
      eventLabel: filename,
    },
  })
}

export const triggerCompletedEvent = () => {
  window.dataLayer.push({
    event: "ga4_event",
    event_name: "HVAC_quiz_completed",
    HVAC_quiz_completed: {
      eventCategory: "HVAC quiz",
      eventAction: "completed",
      eventLabel: undefined,
    },
  })
}

export const triggerResultBackEvent = () => {
  window.dataLayer.push({
    event: "ga4_event",
    event_name: "HVAC_quiz_result_back",
    HVAC_quiz_result_back: {
      eventCategory: "HVAC quiz",
      eventAction: "result back",
      eventLabel: undefined,
    },
  })
}
